interface AuthLayoutProps {
  children: React.ReactNode;
}

export function AuthLayout({ children }: AuthLayoutProps) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-900 px-4">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <h1 className="text-4xl font-bold text-white">cinbulk</h1>
          <p className="text-gray-400 mt-2">Azure Web Stack Template</p>
        </div>
        {children}
      </div>
    </div>
  );
}
